import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multiAssessmentSearchPipe',
  pure: false
})
export class MultiAssessmentSearchPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items || items.length === 0) return [];

    // Clean and normalize the search text to handle special characters
    const term = this.normalizeSearchText(searchText);

    // If no search term, return all items in original order
    if (!term) {
      return items;
    }

    const matchingItems: any[] = [];
    const nonMatchingItems: any[] = [];

    items.forEach(item => {
      const displayValue = this.getDisplayValue(item);
      if (!displayValue) {
        // If no display value, add to non-matching items
        nonMatchingItems.push(item);
        return;
      }

      // Normalize the display value for comparison
      const normalizedDisplayValue = this.normalizeSearchText(displayValue);

      // Check if the display value contains the search term
      if (normalizedDisplayValue.includes(term)) {
        matchingItems.push(item);
      } else {
        nonMatchingItems.push(item);
      }
    });

    // Prioritize items that start with the search term, then includes
    const startsWithItems: any[] = [];
    const includesItems: any[] = [];

    matchingItems.forEach(item => {
      const displayValue = this.getDisplayValue(item);
      if (!displayValue) return;

      const normalizedDisplayValue = this.normalizeSearchText(displayValue);

      if (normalizedDisplayValue.startsWith(term)) {
        startsWithItems.push(item);
      } else {
        includesItems.push(item);
      }
    });

    // Return items with search matches prioritized at the top in original order
    return [...startsWithItems, ...includesItems, ...nonMatchingItems];
  }

  private normalizeSearchText(text: string): string {
    if (!text) return '';

    // Convert to string, trim whitespace, and convert to lowercase
    // This handles both cases: with and without special characters
    // Preserves all characters (including special ones) while normalizing case
    return text.toString().trim().toLowerCase();
  }

  private getDisplayValue(item: any): string | null {
    if (!item) return null;

    if (typeof item === 'string') return item;

    // Check common property names for display values
    if (item.displayExp !== undefined && item.displayExp !== null) {
      return item.displayExp.toString().trim();
    }
    if (item.templateName !== undefined && item.templateName !== null) {
      return item.templateName.toString().trim();
    }
    if (item.formName !== undefined && item.formName !== null) {
      return item.formName.toString().trim();
    }
    if (item.name !== undefined && item.name !== null) {
      return item.name.toString().trim();
    }
    if (item.valueExp !== undefined && item.valueExp !== null) {
      return item.valueExp.toString().trim();
    }

    return null;
  }

  private isItemSelected(itemValue: any, allItems: any[]): boolean {
    // This method tries to detect if an item is selected by checking various patterns
    // It looks for common selection indicators in the data structure

    // Check if the item has any selection-related properties
    const item = allItems.find(i =>
      i.valueExp === itemValue ||
      i.displayExp === itemValue ||
      i.id === itemValue
    );

    if (item) {
      // Check for common selection indicators
      return item.selected === true ||
        item.isSelected === true ||
        item.checked === true ||
        item.value === true ||
        (item.status?.toLowerCase() === 'selected') ||
        (item.state?.toLowerCase() === 'selected');
    }

    return false;
  }
}



